// extracted by mini-css-extract-plugin
export default {"trailContainer":"ModalTrails_trailContainer__CZYOM"};